var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9633 20.4167L20.435 8.58341C20.3164 8.39438 20.2506 8.17709 20.2442 7.95405C20.2379 7.731 20.2913 7.51032 20.3989 7.31484C20.5065 7.11936 20.6644 6.9562 20.8562 6.84225C21.048 6.7283 21.2669 6.66771 21.49 6.66675L29.0917 6.66675C29.5129 6.66783 29.9271 6.77535 30.2957 6.97931C30.6643 7.18327 30.9753 7.47707 31.2 7.83342L38.3583 19.0751C38.6134 19.4761 38.7488 19.9415 38.7488 20.4167C38.7488 20.892 38.6134 21.3574 38.3583 21.7584L31.2 33.0001C30.9753 33.3564 30.6643 33.6502 30.2957 33.8542C29.9271 34.0581 29.5129 34.1657 29.0917 34.1667H21.49C21.2661 34.1663 21.0464 34.1059 20.8538 33.9917C20.6612 33.8775 20.5028 33.7137 20.3951 33.5174C20.2873 33.3212 20.2342 33.0996 20.2412 32.8758C20.2482 32.652 20.3151 32.4342 20.435 32.2451L27.9633 20.4167Z",
    stroke: "#FAAF0C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97334 20.4167L1.445 8.58335C1.32645 8.39431 1.26059 8.17703 1.25423 7.95398C1.24788 7.73094 1.30127 7.51025 1.40887 7.31477C1.51646 7.11929 1.67436 6.95613 1.86621 6.84218C2.05805 6.72824 2.27687 6.66764 2.5 6.66668L10.1 6.66668C10.5215 6.66749 10.936 6.77487 11.3049 6.97884C11.6738 7.18282 11.9852 7.47677 12.21 7.83335L19.3683 19.0833C19.6234 19.4844 19.7589 19.9498 19.7589 20.425C19.7589 20.9003 19.6234 21.3657 19.3683 21.7667L12.2017 33.0167C11.9768 33.3733 11.6655 33.6672 11.2966 33.8712C10.9277 34.0752 10.5132 34.1825 10.0917 34.1833H2.5C2.2761 34.1829 2.05641 34.1225 1.86382 34.0083C1.67123 33.8941 1.51281 33.7303 1.40505 33.534C1.2973 33.3378 1.24417 33.1162 1.2512 32.8924C1.25822 32.6686 1.32515 32.4508 1.445 32.2617L8.97334 20.4167Z",
    stroke: "#FAAF0C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartDashboard);
export default __webpack_public_path__ + "static/media/startDashboard.7b55157e66d1b49b068a1dc50bdbe45f.svg";
export { ForwardRef as ReactComponent };